module.exports = __webpack_public_path__ + "static/media/snapshot3a.d03b5d8e.png";